import React, { Component } from "react";
import { Route } from "react-router-dom";
import PropTypes from "prop-types";
import TourIndexPage from "../app/TourIndexPage";
import TourAddress from "../app/TourAddress";
import DownloadPage from "../app/DownloadPage";
import Flyer from "../app/Flyer";
import Info from "../app/Info";
import Links from "../app/Links";
import MediaEdit from "../app/MediaEdit";
import MediaSettingsPage from "../app/MediaSettingsPage";
import Mls from "../app/Mls";
import Settings from "../app/Settings";
import Immersive3dTourPage from "../app/Immersive3dTourPage";
import Stats from "../app/Stats";
import VideoRequest from "../app/VideoRequest";
import RansomReviewPage from "../app/RansomReviewPage";
import TourStore from "~/stores/TourStore";
import MlsServiceStore from "~/stores/MlsService/MlsServiceStore";
import TourIndexStore from "../stores/TourIndexStore";
import ConstantStore from "~/stores/ConstantStore";
import User from "~/models/User";
import AudioStore from "~/stores/AudioStore";
import ToastMessageStore from "~/stores/ToastMessageStore";
import TourUiMeet3dPage from "~/applications/panel/app/TourUiMeet3dPage";

class TourRoutes extends Component {
  /**
   * @type {TourStore}
   */
  tourStore;

  /**
   * @type {TourIndexStore}
   */
  tourIndexStore;

  /**
   * @type {MlsServiceStore}
   */
  mlsServiceStore;

  constructor(props) {
    super(props);
    this.tourStore = new TourStore();
    this.tourIndexStore = new TourIndexStore();
    this.mlsServiceStore = new MlsServiceStore();
    // Bigger maximum limit to get all Mls Services at once
    this.mlsServiceStore.pagination.itemsPerPage = 1000;
    this.audioStore = new AudioStore();
    // Bigger maximum limit to get all Audios at once
    this.audioStore.pagination.itemsPerPage = 1000;
  }

  render() {
    const { constantStore, user, toastMessageStore } = this.props;
    return (
      <>
        <Route
          exact
          path={["/tours/:tourId(\\d+)", "/tours/:tourId(\\d+)/download", "/tours/:tourId(\\d+)/download/:token"]}
          render={props => (
            <DownloadPage {...props} tourStore={this.tourStore} user={user} toastMessageStore={toastMessageStore} />
          )}
        />
        <Route
          exact
          path="/tours/:tourId(\d+)/info"
          render={props => (
            <Info
              {...props}
              tourStore={this.tourStore}
              constantStore={constantStore}
              user={user}
              toastMessageStore={toastMessageStore}
            />
          )}
        />
        <Route
          exact
          path="/tours/:tourId(\d+)/address"
          render={props => (
            <TourAddress {...props} tourStore={this.tourStore} user={user} toastMessageStore={toastMessageStore} />
          )}
        />
        <Route
          exact
          path="/tours/:tourId(\d+)/mls"
          render={props => (
            <Mls
              {...props}
              tourStore={this.tourStore}
              mlsServiceStore={this.mlsServiceStore}
              user={user}
              toastMessageStore={toastMessageStore}
            />
          )}
        />
        <Route
          exact
          path="/tours/:tourId(\d+)/settings"
          render={props => (
            <Settings {...props} tourStore={this.tourStore} user={user} toastMessageStore={toastMessageStore} />
          )}
        />
        <Route
          exact
          path="/tours/:tourId(\d+)/immersive-3d-tour"
          render={props => (
            <Immersive3dTourPage
              {...props}
              tourStore={this.tourStore}
              user={user}
              toastMessageStore={toastMessageStore}
            />
          )}
        />
        <Route
          exact
          path="/tours/:tourId(\d+)/ui-meet-3d"
          render={props => (
            <TourUiMeet3dPage {...props} tourStore={this.tourStore} user={user} toastMessageStore={toastMessageStore} />
          )}
        />
        <Route
          exact
          path="/tours/:tourId(\d+)/media-edit"
          render={props => (
            <MediaEdit {...props} tourStore={this.tourStore} user={user} toastMessageStore={toastMessageStore} />
          )}
        />
        <Route
          exact
          path="/tours/:tourId(\d+)/media-settings"
          render={props => (
            <MediaSettingsPage
              {...props}
              tourStore={this.tourStore}
              audioStore={this.audioStore}
              user={user}
              toastMessageStore={toastMessageStore}
            />
          )}
        />
        <Route
          exact
          path="/tours/:tourId(\d+)/video-request"
          render={props => (
            <VideoRequest {...props} tourStore={this.tourStore} user={user} toastMessageStore={toastMessageStore} />
          )}
        />
        <Route
          exact
          path="/tours/:tourId(\d+)/flyer"
          render={props => (
            <Flyer {...props} tourStore={this.tourStore} user={user} toastMessageStore={toastMessageStore} />
          )}
        />
        <Route
          exact
          path="/tours/:tourId(\d+)/stats"
          render={props => (
            <Stats {...props} tourStore={this.tourStore} user={user} toastMessageStore={toastMessageStore} />
          )}
        />
        <Route
          exact
          path="/tours/:tourId(\d+)/links"
          render={props => (
            <Links {...props} tourStore={this.tourStore} user={user} toastMessageStore={toastMessageStore} />
          )}
        />
        <Route
          exact
          path="/tours/:tourId(\d+)/review"
          render={props => (
            <RansomReviewPage {...props} tourStore={this.tourStore} user={user} toastMessageStore={toastMessageStore} />
          )}
        />
        <Route
          exact
          path="(/|/tours)"
          render={props => (
            <TourIndexPage
              {...props}
              tourIndexStore={this.tourIndexStore}
              user={user}
              toastMessageStore={toastMessageStore}
            />
          )}
        />
      </>
    );
  }
}
TourRoutes.propTypes = {
  constantStore: PropTypes.instanceOf(ConstantStore),
  user: PropTypes.instanceOf(User),
  toastMessageStore: PropTypes.instanceOf(ToastMessageStore),
};
export default TourRoutes;
